import {StateLabel} from "@platform/models/state-labels/state-label"
import {PaymentState} from "@generated"

export const PaymentStateLabels: Map<PaymentState, StateLabel<PaymentState>> = new Map([
    [PaymentState.OrderPlaced, {state: PaymentState.OrderPlaced, label: "Order placed", background: "#989898", queryParam: "10"}],
    [PaymentState.InvoiceDrafted, {state: PaymentState.InvoiceDrafted, label: "Invoice drafted", background: "#ffab4a", queryParam: "20"}],
    // [PaymentState.InvoiceIssued, {state: PaymentState.InvoiceIssued, label: "Invoice issued", background: "#ffab4a", queryParam: "30"}],
    [PaymentState.Paid, {state: PaymentState.Paid, label: "Paid", background: "#7ec17a", queryParam: "40"}],
])
